/**
 * „Zaznacz wszystkie zgody" — Figma 196:21794.
 *
 * Pole `selectAll` jest niemapowane (nie trafia do encji), służy tylko do
 * przeklikania wszystkich zgód naraz. Działa w obie strony: odznaczenie
 * pojedynczej zgody odznacza też „wszystkie", a zaznaczenie ostatniej brakującej
 * — zaznacza. Stan pośredni pokazuje `indeterminate`.
 */
import { mount } from '../dom-lifecycle';

mount('[data-consents-all]', function () {
	const master = this;
	const $consents = $(this.form).find('.c-consents__item input[type=checkbox]');

	$(master).on('change', () => {
		master.indeterminate = false;
		$consents.prop('checked', master.checked);
	});

	$consents.on('change', () => {
		const checked = $consents.filter(':checked').length;

		master.checked = checked === $consents.length;
		master.indeterminate = checked > 0 && checked < $consents.length;
	});

	// `reset` leci przed wyczyszczeniem pól, więc stan liczymy po nim.
	$(this.form).on('reset', () => setTimeout(() => {
		master.checked = false;
		master.indeterminate = false;
	}));
});
